import { render, staticRenderFns } from "./ViewHero.vue?vue&type=template&id=0c7f7bce&scoped=true&"
import script from "./ViewHero.vue?vue&type=script&lang=js&"
export * from "./ViewHero.vue?vue&type=script&lang=js&"
import style0 from "./ViewHero.vue?vue&type=style&index=0&id=0c7f7bce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7f7bce",
  null
  
)

export default component.exports